<template>
  <div class="line-items-table-tax-summaries">
    <div v-for="tax in summaryTaxes"
         :key="`tax-${tax.id}`"
         class="line-items-table-body-item px-i">
      <div class="line-items-table-cell col-12 col-sm-14">
        {{ taxName(tax) }} ({{ taxRate(tax) | formatPercentage }})
      </div>
      <div class="line-items-table-cell col-12 col-sm-10 text-right">
        {{ formatInvoiceCurrency(taxAmount(tax)) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import Mixin from "./Mixin";

export default {
  mixins: [
    Mixin
  ],

  computed: {
    ...mapGetters("lineItemsTable", [
      "summaryTaxes",
      "taxAmount",
      "taxName",
      "taxRate"
    ])
  }
};
</script>
